import { useTranslation } from 'react-i18next';
import navEN from './translate/nav_en.json.js';
import navES from './translate/nav_es.json.js';

const useTranslate = ()=>{
    const translate = useTranslation();
    //  Add any missing resource bundles
    if (!translate.i18n.hasResourceBundle("en", "nav")) {
        translate.i18n.addResourceBundle("en", "nav", navEN);
    }
    if (!translate.i18n.hasResourceBundle("es", "nav")) {
        translate.i18n.addResourceBundle("es", "nav", navES);
    }
    // TODO the t function doesn't get the new translations
    return translate.t;
};

export { useTranslate };
